import { postWithJson, get } from 'library/utils/serviceUtil'

/**
 * 草稿列表
 */
export const getDraftList = () => {
	return postWithJson('/roc/applet/draftList.np')
}

/**
 * 将草稿添加到代码模板库
 */
export const addDraftToTemp = (params) => {
	return postWithJson('/roc/applet/addDraftToTemplate.np', params)
}

/**
 * 删除模板
 */
export const delTemplate = (params) => {
	return postWithJson('/roc/applet/delTemplate.np', params)
}

/**
 * 小程序模板列表
 */
export const getTemplateList = () => {
	return postWithJson('/roc/applet/templateList.np')
}

/**
 * 小商店列表
 */
export const getShopList = (params) => {
	return postWithJson('/roc/applet/shopList.np', params)
}

/**
 * 审核发布
 */
export const auditAndRelease = (params) => {
	return postWithJson('/roc/applet/auditAndRelease.np', params)
}